import { FC } from 'react'
import clsx from 'clsx'

import WidthLimiter from 'containers/width-limiter/width-limiter'
import ArticleDateViews from '../../../parts/article-date-views/article-date-views'
import LikeShare from '../../../parts/like-share/like-share'

import { originShare } from 'utils/analytics/other/share_material/share_material'

import styles from './article-title.module.scss'

interface IArticleTitle {
  title: string
  themes: string[]
  startDate?: string | Date
  origin?: originShare
  modificator?: string
  showLikeShare?: boolean
  noDateViews?: boolean
  comments?: number
}

const ArticleTitle: FC<IArticleTitle> = ({
  title,
  startDate,
  themes,
  modificator,
  showLikeShare,
  noDateViews,
  comments,
  origin = originShare.ARTICLE,
}: IArticleTitle) => (
  <header className={clsx(styles.articleHeader, { [modificator as string]: modificator })}>
    <WidthLimiter
      noTopPadding
      noBottomPadding
      noLeftPadding
      noRightPadding
      modificator={styles.articleContainer}
    >
      <div className={styles.row}>
        {Boolean(themes?.length) && (
          <div className={styles.themes}>
            {/* {themes.map((themeName, i) => {
              const isLast = themes.length !== i + 1
              return (
                <span className={styles.category} key={themeName}>
                  {themeName}
                  {isLast && <>,&nbsp;</>}
                </span>
              )
            })} */}
          </div>
        )}
        {!noDateViews && (
          <div className={styles.articleViews}>
            <ArticleDateViews date={startDate} comments={comments} />
          </div>
        )}
      </div>
      <h1 className={styles.title}>{title}</h1>
      {showLikeShare && (
        <div className={styles.likeShare}>
          <LikeShare AData={{ origin }} />
        </div>
      )}
    </WidthLimiter>
  </header>
)

export default ArticleTitle
